import TopBar, { TopBarProps } from './TopBar';

export type { TopBarProps };
export default TopBar;
